import React, {Component, Children} from 'react';
import PropTypes from 'prop-types';
import InstrumentListComponent from '../InstrumentList/InstrumentListComponent';
import TradeActivityComponent from '../TradeActivityComponent/TradeActivityComponent';
import { Responsive, WidthProvider as widthProvider } from 'react-grid-layout';
import * as commonActions from './../../actions/commonActions';
import { connect } from 'react-redux';
const ResponsiveReactGridLayout = widthProvider(Responsive);
@connect(
  state => ({language:state.dashboardRoot.commonReducer.language
  }),
    {...commonActions})

export default class StaticPanelComponent extends Component{
  static propTypes = {
    language:PropTypes.string,
  };
  componentDidMount() {
  }
render(){
      return(
        <ResponsiveReactGridLayout  className="layout"
           // cols={{lg: 12, md: 12, sm: 12, xs:0,xxs:0}}
           cols={{lg: 10, md: 10, sm: 10, xs:0,xxs:0}}
           autoSize={true}
           useCSSTransforms={true}
           margin={ [10, 10] }
           compactType={`horizontal`}
            rowHeight={32}>
            <div key="instList1" data-grid={{ x: 0, y: 0, w:4, h: 6, static: true }}>
              <InstrumentListComponent props={this.props.language}/>
            </div>
           <div key="trdeBook2" data-grid={{ x: 4, y: 0, w: 6, h: 6, static: true }}>
             <TradeActivityComponent props={this.props.language}/>
           </div>
        </ResponsiveReactGridLayout>
      )
}
}
